
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fRcce", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "getBuildInfoFromKey", () => $6a42ab2e996003d0$export$38ac5ad36585402e);
$parcel$export(module.exports, "getEndpointUrl", () => $6a42ab2e996003d0$export$c54f5a49b5be9709);
$parcel$export(module.exports, "default", () => $6a42ab2e996003d0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6eHOp = parcelRequire("6eHOp");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $iFaP4 = parcelRequire("iFaP4");

var $9JIJk = parcelRequire("9JIJk");

var $3hRxq = parcelRequire("3hRxq");

var $aSDDo = parcelRequire("aSDDo");

var $kyq27 = parcelRequire("kyq27");
// 10 min polling interval
const $6a42ab2e996003d0$var$DEFAULT_POLLING_INTERVAL = 600000;
const $6a42ab2e996003d0$var$DEBUG_MODE_POLLING_INTERVAL = 10000;
const $6a42ab2e996003d0$var$storageProvider = (0, $3hRxq.createLocalStorageProvider)('', false);
const $6a42ab2e996003d0$var$getDebugModeFromLocalStorage = ()=>{
    try {
        let isDebugModeSetInLocalStorage;
        if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) isDebugModeSetInLocalStorage = $6a42ab2e996003d0$var$storageProvider.get('remote-actions-debug-mode');
        else isDebugModeSetInLocalStorage = localStorage.getItem('remote-actions-debug-mode');
        return isDebugModeSetInLocalStorage === 'true';
    } catch (e) {
        return false;
    }
};
const $6a42ab2e996003d0$var$getDebugModeProps = (isRemoteActionsDebugMode)=>{
    if (isRemoteActionsDebugMode) return {
        product: 'jira.preview',
        pollingInterval: $6a42ab2e996003d0$var$DEBUG_MODE_POLLING_INTERVAL
    };
    return {
        product: 'jira',
        pollingInterval: $6a42ab2e996003d0$var$DEFAULT_POLLING_INTERVAL
    };
};
const $6a42ab2e996003d0$var$matchBuildKey = (buildKey, buildKeyPattern)=>{
    const buildNumber = buildKey.match(buildKeyPattern);
    if (buildNumber) return parseInt(buildNumber[1], 10);
    throw new Error('Invalid build key');
};
const $6a42ab2e996003d0$export$38ac5ad36585402e = (buildKey)=>{
    if (buildKey === 'JF-TEST') return {
        buildNumber: Number.MAX_VALUE,
        buildType: 'local'
    };
    if (buildKey.startsWith('MRJF-BB')) return {
        buildNumber: Number.MAX_VALUE,
        buildType: 'branch'
    };
    if (buildKey.startsWith('MRJF-PROD-ALT')) return {
        buildNumber: $6a42ab2e996003d0$var$matchBuildKey(buildKey, /^MRJF-PROD-ALT-(\d+)(-\w+)?$/),
        buildType: 'alt'
    };
    if (buildKey.startsWith('MRJF-PROD-HOTFIX')) return {
        buildNumber: $6a42ab2e996003d0$var$matchBuildKey(buildKey, /^MRJF-PROD-HOTFIX-(\d+)(-\w+)?$/),
        buildType: 'hotfix'
    };
    return {
        buildNumber: $6a42ab2e996003d0$var$matchBuildKey(buildKey, /^MRJF-PROD-(\d+)(-\w+)?$/),
        buildType: 'prod'
    };
};
const $6a42ab2e996003d0$var$fireLifecycleAnalytics = (analyticsEvent, eventAction, attributes)=>{
    if ((0, $4cTDP.fg)('remote-actions-lifecycle-analytics_9n9tr')) (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'remoteActions',
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        frontendVersion: window.BUILD_KEY,
        ...attributes
    });
};
const $6a42ab2e996003d0$export$c54f5a49b5be9709 = (isStaging, isFedrampPerimeter)=>{
    if (isFedrampPerimeter) {
        if (isStaging) return 'https://update-remote-action.stg.frontend.cdn.atlassian-us-gov-mod.com/assets';
        return 'https://update-remote-action.frontend.cdn.atlassian-us-gov-mod.com/assets';
    }
    if (isStaging) return 'https://update-remote-action.stg-east.frontend.public.atl-paas.net/assets';
    return 'https://update-remote-action.prod-east.frontend.public.atl-paas.net/assets';
};
const $6a42ab2e996003d0$var$RemoteActions = ()=>{
    const isStaging = (0, $kyq27.useIsStagingOrDevOrLocal)();
    const [debugModeProps, setDebugModeProps] = (0, $eJOHy.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const props = $6a42ab2e996003d0$var$getDebugModeProps($6a42ab2e996003d0$var$getDebugModeFromLocalStorage());
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state
        setDebugModeProps(props);
    }, []);
    const onLifecycleEvent = (0, $eJOHy.useCallback)(({ action: action, attributes: attributes })=>{
        $6a42ab2e996003d0$var$fireLifecycleAnalytics(createAnalyticsEvent({}), action, attributes);
    }, [
        createAnalyticsEvent
    ]);
    const endpointUrl = $6a42ab2e996003d0$export$c54f5a49b5be9709(isStaging, (0, $aSDDo.isFedRamp)());
    const productData = (0, $eJOHy.useMemo)(()=>({
            getBuildKey: ()=>typeof window !== 'undefined' ? window.BUILD_KEY : '',
            getBuildInfoFromKey: $6a42ab2e996003d0$export$38ac5ad36585402e,
            getFeatureGateValue: (0, $4cTDP.fg),
            getFeatureFlagValue: (0, $6eHOp.ff)
        }), []);
    if (!endpointUrl || !debugModeProps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JIJk.default), {
        endpoint: endpointUrl,
        product: debugModeProps.product,
        productData: productData,
        pollingInterval: debugModeProps.pollingInterval,
        onLifecycleEvent: onLifecycleEvent
    });
};
var $6a42ab2e996003d0$export$2e2bcd8739ae039 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('remote_actions_-_killswitch_-_temporary'), $6a42ab2e996003d0$var$RemoteActions, ()=>null);

});
parcelRegister("9JIJk", function(module, exports) {
$parcel$export(module.exports, "default", () => $48eeb16968de3b66$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGeP4 = parcelRequire("eGeP4");

var $kOXW8 = parcelRequire("kOXW8");

var $9q63x = parcelRequire("9q63x");
const $48eeb16968de3b66$var$EmitAnalyticsOnNewActionsProcessed = ({ onLifecycleEvent: onLifecycleEvent })=>{
    const lastUpdatedAt = (0, $9q63x.useRemoteActionLastUpdatedAt)();
    const remoteActionsData = (0, $9q63x.useRemoteActionsData)();
    (0, $eJOHy.useEffect)(()=>{
        if (lastUpdatedAt > 0) onLifecycleEvent({
            action: 'pendingActions',
            attributes: {
                lastUpdatedAt: lastUpdatedAt,
                hasPendingActions: Object.keys(remoteActionsData).length > 0,
                pendingActionsIds: Object.keys(remoteActionsData)
            }
        });
    }, [
        lastUpdatedAt,
        remoteActionsData,
        onLifecycleEvent
    ]);
    return null;
};
const $48eeb16968de3b66$var$RemoteActionsManagerInternal = ({ endpoint: endpoint, product: product, productData: productData, pollingInterval: pollingInterval, idleTime: idleTime, onLifecycleEvent: onLifecycleEvent })=>{
    const onPollingError = (0, $eJOHy.useCallback)(()=>{
        if (onLifecycleEvent) onLifecycleEvent({
            action: 'pollingError'
        });
    }, [
        onLifecycleEvent
    ]);
    (0, $kOXW8.useRemoteActionsOnInterval)({
        endpoint: endpoint,
        product: product,
        productData: productData,
        pollingInterval: pollingInterval,
        idleTime: idleTime,
        onPollingError: onPollingError
    });
    return onLifecycleEvent ? /*#__PURE__*/ (0, $gt9Am.jsx)($48eeb16968de3b66$var$EmitAnalyticsOnNewActionsProcessed, {
        onLifecycleEvent: onLifecycleEvent
    }) : null;
};
const $48eeb16968de3b66$var$RemoteActionsManager = (props)=>{
    const { product: product, onLifecycleEvent: onLifecycleEvent } = props;
    const isLocalStorageSupportedRef = (0, $eJOHy.useRef)((0, $eGeP4.isLocalStorageSupported)());
    (0, $eJOHy.useEffect)(()=>{
        if (!isLocalStorageSupportedRef.current) {
            if (onLifecycleEvent) onLifecycleEvent({
                action: 'disabled',
                attributes: {
                    reason: 'LOCALSTORAGE_UNSUPPORTED'
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!isLocalStorageSupportedRef.current) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9q63x.RemoteActionsContainer), {
        product: product,
        isGlobal: true,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($48eeb16968de3b66$var$RemoteActionsManagerInternal, {
            ...props
        })
    });
};
var $48eeb16968de3b66$export$2e2bcd8739ae039 = $48eeb16968de3b66$var$RemoteActionsManager;

});
parcelRegister("eGeP4", function(module, exports) {
$parcel$export(module.exports, "isLocalStorageSupported", () => $49fd9eb2813c9de4$export$bd6fa5db394a4992);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $49fd9eb2813c9de4$export$bd6fa5db394a4992 = ()=>{
    try {
        // use an random key to test
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};

});

parcelRegister("kOXW8", function(module, exports) {
$parcel$export(module.exports, "useRemoteActionsOnInterval", () => $254cb33a4e5c89bb$export$ee582f7d4b1ff42f);

var $eJOHy = parcelRequire("eJOHy");

var $fSaN7 = parcelRequire("fSaN7");

var $9q63x = parcelRequire("9q63x");
const $254cb33a4e5c89bb$export$ee582f7d4b1ff42f = ({ endpoint: endpoint, product: product, productData: productData, onPollingError: onPollingError, pollingInterval: pollingInterval, idleTime: idleTime })=>{
    const [{ isLoaded: isLoaded }, { processRemoteActions: processRemoteActions }] = (0, $9q63x.useRemoteActions)((state)=>({
            isLoaded: state.isLoaded
        }));
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoaded) return;
        const remoteActionPollingService = new (0, $fSaN7.RemoteActionsPollingService)(endpoint, product, (response)=>{
            processRemoteActions(productData, response);
        }, onPollingError, pollingInterval, idleTime);
        return ()=>remoteActionPollingService.destroy();
    }, [
        processRemoteActions,
        isLoaded,
        product,
        productData,
        onPollingError,
        endpoint,
        pollingInterval,
        idleTime
    ]);
};

});
parcelRegister("fSaN7", function(module, exports) {
$parcel$export(module.exports, "RemoteActionsPollingService", () => $574b8f77320e08ee$export$6279e159d4acc1e);

var $dVcSp = parcelRequire("dVcSp");


var $j9Z42 = parcelRequire("j9Z42");
const $574b8f77320e08ee$var$createBroadcastChannel = (channelName)=>{
    try {
        // eslint-disable-next-line compat/compat
        return new BroadcastChannel(channelName);
    } catch  {
        return undefined;
    }
};
var $574b8f77320e08ee$export$50f695ee7ce4b786 = /*#__PURE__*/ function(PollingState) {
    PollingState["POLLING"] = "polling";
    PollingState["SUSPENDED"] = "suspended";
    PollingState["DESTROYED"] = "destroyed";
    return PollingState;
}({});
class $574b8f77320e08ee$export$6279e159d4acc1e {
    constructor(endpoint, product, onRemoteActionsUpdate, onPollingError, pollingInterval, idleTime){
        this.endpoint = endpoint;
        this.product = product;
        this.onRemoteActionsUpdate = onRemoteActionsUpdate;
        this.onPollingError = onPollingError;
        this.pollingState = "suspended";
        this.lastUpdateReceivedAt = Date.now();
        this.pollingInterval = pollingInterval || (0, $3f3051588b570bb3$export$f2b2f5ef0b498d26);
        this.broadcastChannel = $574b8f77320e08ee$var$createBroadcastChannel(`${(0, $3f3051588b570bb3$export$388bd7a7ebb11e7)}-${product}`);
        this.broadcastChannel?.addEventListener('message', (event)=>{
            if (event.data.messageType === 'remote-action-polled') {
                this.lastUpdateReceivedAt = Date.now();
                if (!this.lastResponse?.lastUpdatedAt || this.lastResponse.lastUpdatedAt < event.data.response.lastUpdatedAt) {
                    this.lastResponse = event.data.response;
                    this.onRemoteActionsUpdate(event.data.response);
                }
            }
        });
        this.intervalInstance = setInterval(()=>{
            if (this.pollingState === "polling") this.fetchRemoteActions();
        }, this.pollingInterval || (0, $3f3051588b570bb3$export$f2b2f5ef0b498d26));
        this.browserInteractionTime = new (0, $dVcSp.default)({
            idleTimeoutMs: idleTime || (0, $3f3051588b570bb3$export$af2ff676951003fe),
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                this.onActive.bind(this)
            ],
            browserTabInactiveCallbacks: [
                this.onInactive.bind(this)
            ],
            activeCallbacks: [
                this.onActive.bind(this)
            ],
            idleCallbacks: [
                this.onInactive.bind(this)
            ]
        });
        this.browserInteractionTime.startTimer();
        this.start();
    }
    onActive() {
        if (this.pollingState === "suspended") this.start();
    }
    onInactive() {
        if (this.pollingState === "polling") this.suspend();
    }
    async fetchRemoteActions() {
        try {
            if (Date.now() - this.lastUpdateReceivedAt >= this.pollingInterval) {
                const response = await (0, $j9Z42.getRemoteActions)(this.endpoint, this.product);
                if (response) {
                    this.lastUpdateReceivedAt = Date.now();
                    if (!this.lastResponse?.lastUpdatedAt || this.lastResponse?.lastUpdatedAt < response.lastUpdatedAt) {
                        this.lastResponse = response;
                        this.onRemoteActionsUpdate(response);
                    }
                    if (this.broadcastChannel) this.broadcastChannel.postMessage({
                        response: response,
                        messageType: 'remote-action-polled'
                    });
                }
            }
        } catch (error) {
            this.onPollingError(error);
        }
    }
    start() {
        if (this.pollingState === "destroyed") throw new Error('RemoteActionService instance was destroyed and cannot be started again');
        this.pollingState = "polling";
        // fetch the remote actions immediately (if the last update was more than the polling interval ago)
        this.fetchRemoteActions();
    }
    suspend() {
        this.pollingState = "suspended";
    }
    destroy() {
        if (this.pollingState !== "destroyed") {
            this.suspend();
            clearInterval(this.intervalInstance);
            this.intervalInstance = undefined;
            this.browserInteractionTime?.destroy();
            this.browserInteractionTime = undefined;
            this.broadcastChannel?.close();
            this.broadcastChannel = undefined;
            this.pollingState = "destroyed";
        }
    }
    getState() {
        return this.pollingState;
    }
}

});
const $3f3051588b570bb3$export$f2b2f5ef0b498d26 = 5000;
const $3f3051588b570bb3$export$f2c0b74311ada874 = 3;
const $3f3051588b570bb3$export$af2ff676951003fe = 60000;
const $3f3051588b570bb3$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';

parcelRegister("j9Z42", function(module, exports) {
$parcel$export(module.exports, "getRemoteActions", () => $a5f90e34f5ad9a43$export$6e23e289b6bb0154);
const $a5f90e34f5ad9a43$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $a5f90e34f5ad9a43$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $a5f90e34f5ad9a43$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 1 && $a5f90e34f5ad9a43$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $a5f90e34f5ad9a43$var$timeout(backoff);
        return await $a5f90e34f5ad9a43$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else throw new Error(`Failed to fetch remote actions with status ${response.status}`);
}
const $a5f90e34f5ad9a43$var$getRemoteActionsUrlForProduct = (endpoint, product)=>`${endpoint}/${product}.json`;
const $a5f90e34f5ad9a43$export$6e23e289b6bb0154 = async (endpoint, product)=>{
    const remoteActionsUrl = $a5f90e34f5ad9a43$var$getRemoteActionsUrlForProduct(endpoint, product);
    const response = await $a5f90e34f5ad9a43$var$fetchRetry(remoteActionsUrl, {
        cache: 'no-store',
        method: 'GET'
    });
    if (response && response.ok) {
        const remoteActionsResponse = await response.json();
        if (remoteActionsResponse && typeof remoteActionsResponse.lastUpdatedAt === 'number' && remoteActionsResponse.remoteActions instanceof Array) return remoteActionsResponse;
    }
};

});


parcelRegister("9q63x", function(module, exports) {
$parcel$export(module.exports, "RemoteActionsContainer", () => $50f8dc63fb35b1c8$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $50f8dc63fb35b1c8$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $50f8dc63fb35b1c8$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $50f8dc63fb35b1c8$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionLastUpdatedAt", () => $50f8dc63fb35b1c8$export$1d013261a2e6e0f9);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $50f8dc63fb35b1c8$export$3fd21eaf97df4718);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
var $awqaz = parcelRequire("awqaz");

var $cziY4 = parcelRequire("cziY4");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $awqaz.default))) (0, $awqaz.default).devtools = false;
const $50f8dc63fb35b1c8$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $cziY4.actions,
    name: 'remoteActionsStore'
});
const $50f8dc63fb35b1c8$export$28c2e4c663a86266 = (0, $6E16M.createContainer)($50f8dc63fb35b1c8$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $cziY4.actions).initStore());
        }
});
const $50f8dc63fb35b1c8$export$333357b3de3e67a0 = (selector)=>(0, $iJq0l.createHook)($50f8dc63fb35b1c8$var$Store, {
        selector: selector
    })();
const $50f8dc63fb35b1c8$export$3cc006661ae2a759 = (0, $iJq0l.createStateHook)($50f8dc63fb35b1c8$var$Store, {
    selector: (state)=>state.remoteActions
});
const $50f8dc63fb35b1c8$export$3fb9275d3845bd5a = (0, $iJq0l.createStateHook)($50f8dc63fb35b1c8$var$Store, {
    selector: (state)=>state.meta
});
const $50f8dc63fb35b1c8$export$1d013261a2e6e0f9 = (0, $iJq0l.createStateHook)($50f8dc63fb35b1c8$var$Store, {
    selector: (state)=>state.lastUpdatedAt
});
const $50f8dc63fb35b1c8$export$3fd21eaf97df4718 = (0, $iJq0l.createActionsHook)($50f8dc63fb35b1c8$var$Store);

});
parcelRegister("cziY4", function(module, exports) {
$parcel$export(module.exports, "actions", () => $874434d4c0769139$export$e324594224ef24da);

var $9fvV8 = parcelRequire("9fvV8");

var $8bK2W = parcelRequire("8bK2W");

var $l5i9Z = parcelRequire("l5i9Z");

var $fLUaS = parcelRequire("fLUaS");
const $874434d4c0769139$export$e324594224ef24da = {
    processRemoteActions: $l5i9Z.processRemoteActions,
    saveActionPerformedAttempt: $fLUaS.saveActionPerformedAttempt,
    initStore: $8bK2W.initStore,
    clearActionId: $9fvV8.clearActionId
};

});
parcelRegister("9fvV8", function(module, exports) {
$parcel$export(module.exports, "clearActionId", () => $6ce8bb8c9dfdb805$export$8d8b492eefa9efba);

var $hoIGF = parcelRequire("hoIGF");
const $6ce8bb8c9dfdb805$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $hoIGF.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("hoIGF", function(module, exports) {
$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $b2684cdf604f264c$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $b2684cdf604f264c$export$7228aaade919a8b6);
const $b2684cdf604f264c$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $b2684cdf604f264c$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$b2684cdf604f264c$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $b2684cdf604f264c$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$b2684cdf604f264c$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("8bK2W", function(module, exports) {
$parcel$export(module.exports, "initStore", () => $b0739f393a595679$export$41f27b3823a442c6);

var $hoIGF = parcelRequire("hoIGF");
const $b0739f393a595679$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $hoIGF.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("l5i9Z", function(module, exports) {
$parcel$export(module.exports, "processRemoteActions", () => $e1c879c7d58bc3e2$export$15e69d1dd38ccaa3);

var $eeJhH = parcelRequire("eeJhH");
const $e1c879c7d58bc3e2$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $eeJhH.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $eeJhH.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            // only keep the meta for the remote actions that are still present. This is to avoid
            // keeping stale meta which would otherwise grow indefinitely.
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: remoteActionsResponse.lastUpdatedAt
        });
    };

});
parcelRegister("eeJhH", function(module, exports) {
$parcel$export(module.exports, "isActionConditionSatisfied", () => $6dda29d64e5b48ca$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $6dda29d64e5b48ca$export$c7cc93192d09a3d7);

var $dhYav = parcelRequire("dhYav");
const $6dda29d64e5b48ca$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $6dda29d64e5b48ca$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $6dda29d64e5b48ca$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $6dda29d64e5b48ca$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $dhYav.ConditionType).buildRange:
            return $6dda29d64e5b48ca$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
        case (0, $dhYav.ConditionType).featureFlag:
            return $6dda29d64e5b48ca$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $dhYav.ConditionType).featureGate:
            return $6dda29d64e5b48ca$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $6dda29d64e5b48ca$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("dhYav", function(module, exports) {
$parcel$export(module.exports, "ConditionType", () => $247c5be640384baa$export$748d1c753cdf4bfd);
var $247c5be640384baa$export$748d1c753cdf4bfd = /*#__PURE__*/ function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
    return ConditionType;
}({});

});



parcelRegister("fLUaS", function(module, exports) {
$parcel$export(module.exports, "saveActionPerformedAttempt", () => $7a4db38b79fd5485$export$e3144a2e886e0e77);

var $hoIGF = parcelRequire("hoIGF");
const $7a4db38b79fd5485$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $hoIGF.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});







//# sourceMappingURL=async-remote-actions.c67926a9.js.map
